document.querySelectorAll('.pr-faq details').forEach((detail) => {
  const summary = detail.querySelector('summary');
  
  // Set initial aria-expanded
  summary.setAttribute('aria-expanded', detail.hasAttribute('open'));

  summary.addEventListener('click', () => {
    // Update aria-expanded after toggle
    summary.setAttribute('aria-expanded', detail.hasAttribute('open'));
  });
});